import React, { useEffect, useState } from "react";
import { Col, Row, Card, Form, Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { Routes } from "routes";
import { useUserDropDownMutation } from "Services/services";
import Select from "react-select";

export default () => {
  const [userDetails] = useUserDropDownMutation();
  //usertype
  const userData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(userData);

  //functional details
  const [formData, setFormData] = useState({
    enterprise: "",
    routeName: "",
    channel: "SMS",
  });
  const [selectedUserOptions, setSelectedUserOptions] = useState({
    value: "",
    label: "Select Users",
  });
  const selectedChannelOptions = [
    { value: "SMS", label: "SMS" },
    { value: "Whatsapp", label: "Whatsapp" },
  ];

  // functional programming

  useEffect(() => {
    const fetchEnterpriceList = async () => {
      try {
        const response = await userDetails({ user_type: 4 });
        if (response?.data?.statusCode === 200) {
          const options = response.data.data.user_details.map((user) => ({
            value: user.id,
            label: `${user.user_name} (${user.email})`,
          }));
          // Add a default "Select CRM" option at the beginning of the options array
          setSelectedUserOptions(options);
        } else {
          console.error("Failed to fetch user data");
        }
      } catch (error) {
        console.error("Error fetching user data", error);
      }
    };

    fetchEnterpriceList();
  }, []);

  // 🔁 Single dynamic handler
  const handleChange = (e) => {
    const value = e.target.value;
    const regex = /^[a-z0-9]{0,8}$/;

    if (regex.test(value)) {
      setFormData((prev) => ({
        ...prev,
        routeName: value,
      }));
    } else {
      setError2(false);
    }
  };

  // const submitForm = (e) => {
  //     e.preventDefault();
  //     vendorRegistration(formPayload)
  //         .then((success) => {
  //             if (success?.data?.statusCode === 200) {
  //                 setToastMessage(success?.data?.message);
  //                 setToastVariant('success');
  //                 setRefreshTable(!refreshTable);
  //                 setFormData({
  //                     vendor: "",
  //                     username: "",
  //                     password: "",
  //                     country: "",
  //                     contactName: "",
  //                     contactEmail: "",
  //                     contactPhone: "",
  //                     websiteUrl: "",
  //                     allowIp: "",
  //                     accountValidity: "",
  //                     retentionPolicy: "",
  //                     complianceCertificate: "",
  //                     gst: "",
  //                 });
  //             } else if (success?.data?.statusCode > 300) {
  //                 console.error('Login failed passed', success.data.message);
  //                 setToastMessage(success.data.message);
  //                 setToastVariant('danger');
  //                 setRefreshTable(!refreshTable);
  //             }
  //             setShowToast(true);
  //         })
  //         .catch((error) => {
  //             setRefreshTable(!refreshTable);
  //             console.error('Login failed', error);
  //             setToastMessage('Vendor onbording fail');
  //             setToastVariant('danger');
  //             setShowToast(true);
  //         });
  // }

  const [error, setError] = useState(false);
  const [error2, setError2] = useState(false);

  const history = useHistory();

  const handleNext = (e) => {
    e.preventDefault();
    if (!formData.enterprise || formData.enterprise === "") {
      setError(true);
      return;
    }
    if (!formData.routeName || formData.routeName === "") {
      setError2(true);
      return;
    }

    history.push({
      pathname: Routes.CreateDefaultRoutingSMSC.path,
      state: formData,
    });
  };

  return (
    <div style={{ minHeight: "80vh" }}>
      <Card border={1} className="mb-3">
        <Card.Body className="p-0">
          <h5 className="mb-4">Add Routing</h5>
          <Form noValidate autoComplete="off">
            <input
              type="text"
              name="preventAutoFill"
              style={{ display: "none" }}
            />
            <Row>
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="enterprise">
                  <Form.Label>Enterprise <span className="text-danger">*</span></Form.Label>
                  <Select
                    options={selectedUserOptions}
                    placeholder="Select User"
                    className={`mb-0 ${error ? "is-invalid" : ""}`}
                    isSearchable={true}
                    value={formData.enterprise}
                    onChange={(selectedOption) => {
                      setFormData((prev) => ({
                        ...prev,
                        enterprise: selectedOption,
                      }));
                      setError(false);
                    }}
                  />
                  {error && (
                    <div className="invalid-feedback d-block">
                      Please select a valid Enterprise.
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="username">
                  <Form.Label>Route Name <span className="text-danger">*</span></Form.Label>
                  <Form.Control
                    required
                    type="text"
                    placeholder="Enter Route Name"
                    pattern="^[a-z0-9]+$"
                    value={formData.routeName}
                    onChange={handleChange}
                    name="routeName"
                  />
                  {error2 && (
                    <div className="invalid-feedback d-block">
                      Please provide a valid Route Name.
                    </div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6} lg={4} className="mb-3">
                <Form.Group id="enterprise">
                  <Form.Label>Channel <span className="text-danger">*</span></Form.Label>
                  {/* <Select
                                            options={selectedChannelOptions}
                                            placeholder="--Select Channel--"
                                            isSearchable={true}
                                            value={formData.channel}
                                            onChange={(selectedOption) => {
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    'channel': selectedOption
                                                }))
                                            }}
                                        /> */}
                  <Form.Control defaultValue={formData.channel} disabled />
                </Form.Group>
              </Col>

              <Col className="mt-3 d-flex">
                <Button
                  type="submit"
                  onClick={handleNext}
                  variant="secondary"
                  className="ms-auto"
                >
                  Next
                </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};
